
export const legal = {
  subtitle: '法律规定及网站政策',
  
  // Section 1: Company Profile & Legal Disclosure
  section1_title: '组织概要 / 特定商业交易法相关说明',
  org_name_label: '机构名称',
  org_name_value: 'Dream Realization Academy（梦想实现学院）',
  director_label: '运营总负责人（理事长）',
  director_value: '廣瀬 進二',
  address_label: '地址',
  address_value: '〒455-0822\n日本爱知县名古屋市港区甚兵卫通5丁目16番地\nCross Gospel Church 2楼',
  contact_label: '联系方式',
  contact_value: '电子邮件：info@dr-academy.net\n※为确保记录的准确性，有关交易或服务的咨询原则上请通过本网站的"INQUIRY（咨询）"表单或电子邮件与我们联系。',
  program_price_label: '提供项目及销售价格',
  program_price_value: 'DREAM CODE 波动共鸣项目（全48讲座·基础项目）：440,000日元（含税）\n※针对企业及教育机构的定制导入，将根据事前需求定义进行单独报价。',
  additional_fees_label: '商品价格以外的必要费用',
  additional_fees_value: '・项目学习及系统使用所需的互联网通信费用',
  payment_method_label: '支付方式',
  payment_method_value: '信用卡支付（通过专用非公开链接提供详情）',
  delivery_label: '交付时间（服务提供时间）',
  delivery_value: '完成规定的适性面谈及入学手续（结算）后，将通过专用学习系统或指定开始日期迅速开始提供项目。',
  cancellation_label: '关于取消及退款',
  cancellation_value: '鉴于所提供项目及数字内容的特性，原则上在完成入学手续（结算）后不接受取消及退款。敬请谅解。',

  // Section 2: Privacy Policy
  section2_title: '隐私政策',
  privacy_intro_title: '',
  privacy_intro_text: 'Dream Realization Academy（以下简称"本机构"）就本机构提供的教育项目及各类服务中个人信息的处理，制定以下隐私政策（以下简称"本政策"）。',
  privacy_1_title: '1. 信息获取与使用目的',
  privacy_1_text: '本机构通过INQUIRY（咨询）表单等途径获取的姓名、所属机构名称、联系方式等信息，仅用于以下目的：\n・回复咨询及提供最佳项目建议\n・项目的提供、运营及相关事务联络\n・本机构主办的国际会议、研讨会、教育信息的通知',
  privacy_2_title: '2. 个人信息的第三方提供',
  privacy_2_text: '除法律规定的情况外，本机构不会在未经事先同意的情况下向第三方提供或披露所获取的个人信息。',
  privacy_3_title: '3. 安全管理措施',
  privacy_3_text: '本机构为防止个人信息的泄露、灭失或损毁，以及确保个人信息的安全管理，采取符合国际标准的必要且适当的措施。',
  privacy_4_title: '4. 免责声明',
  privacy_4_text: '如果您通过本网站的链接或横幅等方式转到其他网站，本机构对转到网站提供的信息、服务等概不负责。',
  privacy_5_title: '5. 咨询窗口',
  privacy_5_text: '有关本政策的咨询，请通过本网站的"INQUIRY"表单联系事务局。',

  // Section 3: Terms of Use & Disclaimer
  section3_title: '使用条款及免责声明',
  terms_1_title: '1. 知识产权保护',
  terms_1_text: '本网站上刊载的所有内容（文章、图片、设计、DREAM CODE相关的"48法则"等结构图·课程体系）的著作权及其他知识产权归Dream Realization Academy及创始人所有。严禁未经许可的复制、转载、修改及商业用途使用。',
  terms_2_title: '2. 项目性质与免责声明',
  terms_2_text: '"DREAM CODE 波动共鸣项目"是一个整合了脑科学、行为心理学、量子力学概念视角，支持个人认知结构重新设计的教育框架。\n本机构致力于提高本项目的学术一致性和教育价值，但本项目并非旨在治疗特定疾病的医疗行为的替代品。此外，明确说明本项目不对学员的绝对经济成功或特定成果提供法律保证。',
  terms_3_title: '3. 条款变更',
  terms_3_text: '本机构在认为必要时，可在不事先通知的情况下变更本条款。变更后的条款自在本网站公示之时起生效。',
};
